import React from 'react';
import { selectorWidth } from "./ManualBillModal.utils";
export default function ManualBillModalSelectionField(props) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: selectorWidth
    }
  }, props.children);
}